;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesJoinByCode = Marionette.ItemView.extend({
		template: _.template(''),
		initialize: function() {
			this.league_id   = this.getOption('league_id');
			this.league_code = this.getOption('league_code');
			this.league      = this.getOption('league');

			this.listenTo(this.league, 'leagues:join:success', this.joinedLeague);
			this.listenTo(this.league, 'leagues:errors', this.checkForErrors);

			this.showPreloader();
			this.league.set({ id: this.league_id, code: this.league_code }).join();
		},
		
		joinedLeague: function() {
			this.hidePreloader();
			
			APP.vent.trigger('popup:message:show', 'You\'ve joined the league!');
			
			this.trigger('leagues_join_code:success', this.league_id);

			return this;
		},

		checkForErrors: function(errors) {
			this.hidePreloader();

			this.showErrors(errors);

			this.trigger('leagues_join_code:error', this.league_id);
		}
	});

}(window, APP, Backbone, Marionette, $, _));